import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setDefaultSidebar } from '@/redux/sidebar/actions';
import { selectUserId } from '@/redux/user/selectors';
import { SidebarOptions } from '@/shared/types/sidebar';

/**
 * Hook to set the default sidebar content when the user navigates to a new page.
 * The middleware will check localStorage to determine if the sidebar should be shown.
 */
export const useSetDefaultSidebar = (sidebar: SidebarOptions) => {
  const dispatch = useDispatch();
  const userId = useSelector(selectUserId);

  useEffect(() => {
    dispatch(setDefaultSidebar(sidebar));
  }, [dispatch, sidebar, userId]);
};
